

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import {IOnOffHandlers} from "bonomo";
  import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
  import {namespace} from "vuex-class";
  import {EPermissionActions} from "@/model/EPermissionActions";
  import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

  const lockerCompanyModule = namespace("lockerCompanyModule");
  const locker2Module = namespace("locker2Module");

  @Component({
    components: {SimpleConfirmationDialog}
  })
  export default class LLandings extends Vue {

    @locker2Module.Action('commitLockerCompanyIds')
    commitLockerCompanyIds!: (companyIds: number[]) => void;

    @lockerCompanyModule.Action('fetchLockerCompanies')
    fetchLockerCompanies!: (filters: any) => void;
    @lockerCompanyModule.Action('connectLockerCompany')
    connectLockerCompany!: (data: any) => void;

    @lockerCompanyModule.Getter('lockerCompanies')
    lockerCompanies!: ILockerCompany[]

    @Prop()
    locker!: ILocker2;
    @Prop()
    disabled!: boolean;
    @Prop()
    editing!: boolean;

    adding: boolean = false;
    addCompanyId: number = 0;
    companyToRemove!: ILockerCompany;
    confirmationDialogShowing: boolean = false;
    loading: boolean = false;
    submitting: boolean = false;
    subscribes: IOnOffHandlers = {};

    get canEdit(): boolean {
      return this.$canAction(EPermissionActions.ACTION_LOCKER_COMPANIES);
    }

    get companyItems(): any[] {
      return this.lockerCompanies
        .filter(each => !this.locker.lockerCompanyIds.includes(each.id))
        .map((each: ILockerCompany) => ({
          text: each.description,
          value: each.id
        }));
    }

    get lockerCompanyItems(): ILockerCompany[] {
      if (!this.lockerCompanies) {
          return [];
      }
      return this.lockerCompanies.filter(each => this.locker.lockerCompanyIds.includes(each.id));
    }

    get title(): string {
      const label = 'lockers.locker.landingPages.titles.' + this.locker.community_vertical;
      const translated = this.$t(label);
      const titlePerVertical = translated == label ? '' : translated + ' / ';
      return titlePerVertical + this.$t('lockers.locker.landingPages.title')
    }

    get userCountConnected(): any {
      let count = 0;
      Object.keys(this.locker.lockerCompanyUserCounts).forEach(
        eachKey => {
          if ((eachKey != "") && (this.companyIsOnLocker(eachKey))) {
            count+= (this.locker.lockerCompanyUserCounts as any)[eachKey];
          }
        }
      )
      return count;
    }

    get usersWithAnyCompany(): number {
      let count = 0;
      Object.keys(this.locker.lockerCompanyUserCounts).forEach(
        eachKey => {
          if (eachKey != "") {
            count+= (this.locker.lockerCompanyUserCounts as any)[eachKey];
          }
        }
      )
      return count;
    }

    created() {
      this.loadData();
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.lockerCompaniesLoaded': this.onLoaded,
        'backend.call.KO.lockerCompaniesLoaded': this.onKO,
        'backend.call.OK.lockersLockerCompaniesLoaded': this.onLockersLockerCompaniesLoaded,
        'backend.call.KO.lockersLockerCompaniesLoaded': this.onKO,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    companyIsOnLocker(companyId: number|string): boolean {
      let ret = false;
      this.lockerCompanyItems.forEach(
        each => {
          if (each.id == companyId) {
            ret = true;
          }
        }
      )
      return ret;
    }

    // we'll abstract these when we reuse
    landingFullUrl(lockerCompany: ILockerCompany) {
      return 'https://smartpoint.ai' + this.landingUrlPath(lockerCompany);
    }

    landingUrlPath(lockerCompany: ILockerCompany) {
      return '/l/' + this.locker.id + '/' + lockerCompany.slug;
    }

    loadData() {
      if (!this.locker || !this.locker.id) {
        return;
      }
      this.loading = true;
      this.fetchLockerCompanies({});
    }

    onAdd() {
      this.submitting = true;
      this.connectLockerCompany({lockerId: this.locker.id, lockerCompanyId: this.addCompanyId, connect: true, });
    }

    onKO() {
      this.submitting = false;
    }

    onLoaded() {
      if (this.submitting) {
        this.$uiBus.emit('success', this.$t('common.saved'));
        this.submitting = false;
      }
      this.adding = false;
      this.loading = false;
    }

    onLockersLockerCompaniesLoaded(lockerCompanies: ILockerCompany[]) {
      this.commitLockerCompanyIds(
          lockerCompanies.map(each => each.id)
      );
      this.submitting = false;
    }

    onRemove(lockerCompany: ILockerCompany) {
      this.confirmationDialogShowing = true;
      this.companyToRemove = lockerCompany;
    }

    onRemoveConfirmed() {
      this.submitting = true;
      this.connectLockerCompany({lockerId: this.locker.id, lockerCompanyId: this.companyToRemove.id, connect: false, });
      this.confirmationDialogShowing = false;
    }

    userCountOf(companyId: number|string): any {
      return (this.locker.lockerCompanyUserCounts  as any)[companyId];
    }

  }

